const calculateTotalPurchasePrice = (state, price)=>{
    if (!price) {
        return;
    }
    let totalQuantity = 0;
    if (state.configurator.left.isEnabled) {
        totalQuantity += state.configurations.left.quantity;
    }
    if (state.configurator.right.isEnabled) {
        totalQuantity += state.configurations.right.quantity;
    }
    var ref;
    const unitPrice = (ref = price === null || price === void 0 ? void 0 : price.discountedPrice) !== null && ref !== void 0 ? ref : price.originalPrice;
    return totalQuantity * unitPrice;
};

export { calculateTotalPurchasePrice };
//# sourceMappingURL=calculate-total-purchase-price.js.map
